// Strażnik kolejności odpowiedzi dla filtrowanych/stronicowanych list.
//
// Chroni przed wyścigiem nieuporządkowanych odpowiedzi: gdy użytkownik szybko
// zmienia filtr/status/stronę, wolniejsza (starsza) odpowiedź może wrócić PO
// szybszej nowszej i nadpisać już wyświetloną listę. Każda akcja-lista tworzy
// własną instancję; przed każdym commitem stanu sprawdza isLatest(id).
//
// Użycie w akcji Vuex:
//   const seq = createRequestSequence();
//   const id = seq.next();
//   const res = await axios.get(url);
//   if (!seq.isLatest(id)) return; // przyszła starsza odpowiedź — porzuć
//   commit("MUTATION", res.data);
export function createRequestSequence() {
  let latest = 0;
  return {
    next: () => ++latest,
    isLatest: (id) => id === latest,
    invalidate: () => {
      ++latest;
    },
  };
}
